export default __webpack_public_path__ + "static/media/listIcon.e2d12852.svg";